<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard For ",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      studentPerClass: {},
      expenseVsRevenue: {},
      feesPerClass: {},
      toggleSearch: "none",
      searchedStudents: [],
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      // showModal: false,
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters("dashboard", ["Dashboard"]),
    ...mapGetters("settings", ["CurrentSettings"]),
    ...mapGetters("students", ["getAllSearchableStudents", "FetchingStudents"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    Dashboard(newVal) {
      //setting up student per class bar graph
      this.studentPerClass = {
        series: [
          {
            name: "Number",
            data: newVal.student_per_class.class_values,
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "45%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#34c38f", "#556ee6", "#f46a6a"],
          xaxis: {
            categories: newVal.student_per_class.class_details,
          },
          yaxis: {
            title: {
              text: "(students)",
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " Students";
              },
            },
          },
        },
      };

      //setting up fees collected per class bar graph
      this.feesPerClass = {
        series: [
          {
            name: "Number",
            data: newVal.fees_per_class.fees_values,
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "45%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#34c38f", "#556ee6", "#f46a6a"],
          xaxis: {
            categories: newVal.fees_per_class.class_details,
          },
          yaxis: {
            title: {
              text: "(Fees)",
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " Fees";
              },
            },
          },
        },
      };

      //setting up expenses vs revenue line graph
      this.expenseVsRevenue = {
        chartOptions: {
          chart: {
            height: 380,
            type: "line",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          colors: ["#556ee6", "#34c38f"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: [3, 3],
            curve: "straight",
          },
          title: {
            text: "Revenues Vs Expenses Graph",
            align: "left",
            style: {
              fontWeight: "500",
            },
          },
          grid: {
            row: {
              colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.2,
            },
            borderColor: "#f1f1f1",
          },
          markers: {
            style: "inverted",
            size: 5,
          },
          xaxis: {
            categories: newVal.expense_vs_revenue.monthly_data,
            title: {
              text: "Month",
            },
          },
          yaxis: {
            title: {
              text: "Amount",
            },
            min: newVal.expense_vs_revenue.min_range,
            max: newVal.expense_vs_revenue.max_range,
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
            floating: true,
            offsetY: -25,
            offsetX: -5,
          },
          responsive: [
            {
              breakpoint: 600,
              options: {
                chart: {
                  toolbar: {
                    show: false,
                  },
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
        },
        series: [
          {
            name: "Revenues",
            data: newVal.expense_vs_revenue.monthly_revenue,
          },
          {
            name: "Expenses",
            data: newVal.expense_vs_revenue.monthly_expense,
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions({
      FetchSettings: "settings/fetchCurrentSettings",
      FetchDashboard: "dashboard/fetchDashboardValues",
      FetchSearchableStudents: "students/fetchSearchableStudents",
    }),

    displayList() {
      this.toggleSearch = "block";
    },
    removeList() {
      setTimeout(() => {
        this.toggleSearch = "none";
      }, 250);
    },
    searchStudent(event) {
      this.searchedStudents = this.getAllSearchableStudents.filter(
        (student) => {
          return student.student.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase());
        }
      );
    },
  },
  created() {
    this.FetchSettings();
    this.FetchDashboard();
    this.FetchSearchableStudents();
  },
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="CurrentSettings ? title + ' YEAR: ' + CurrentSettings.year : '--'"
      :items="items"
    />
    <div class="row mb-3">
      <div class="col-md-8 float-end"></div>
      <!-- <div class="col-md-4 float-end">
        <input
          type="text"
          class="form-control"
          @keyup="searchStudent($event)"
          @focusin="displayList()"
          @blur="removeList()"
          placeholder="Enter Student's Name and search for details"
          id=""
          style="border-radius: 2rem;"
        />
        <div
          class="list-group"
          :style="
            `position: absolute; z-index: 1; width: 25rem; display: ${toggleSearch};`
          "
        >
          <a
            v-if="FetchingStudents"
            href="#"
            class="list-group-item list-group-item-action disabled"
            aria-current="true"
          >
            <i class="fa fa-spinner" aria-hidden="true"></i> Fetching students
            please wait to type....
          </a>
          <a
            v-else
            href="#"
            class="list-group-item list-group-item-action disabled"
            aria-current="true"
          >
            Please type the name for the student to search....
          </a>
          <router-link
            v-for="(searchableStudent, index) in searchedStudents"
            :key="index"
            :to="'/students/details/' + searchableStudent.sid"
            class="list-group-item list-group-item-action"
            aria-current="true"
          >
            {{ searchableStudent.student.name }} | Class:
            {{ searchableStudent.classx.short }} | Stream:
            {{ searchableStudent.streamx.name }}
          </router-link>
        </div>
      </div> -->
      <div class="col-md-4 float-end">
        <input
          type="text"
          class="form-control"
          @keyup="searchStudent($event)"
          @focusin="displayList()"
          @blur="removeList()"
          placeholder="Quick Search, Enter Student's Name."
          id=""
          style="border-radius: 2rem;"
        />
        <div
          class="list-group"
          :style="
            `position: absolute; z-index: 1; width: 25rem; display: ${toggleSearch};`
          "
        >
          <a
            v-if="FetchingStudents"
            href="#"
            class="list-group-item list-group-item-action disabled"
            aria-current="true"
          >
            <i class="fa fa-spinner" aria-hidden="true"></i> Fetching students
            please wait to type....
          </a>
          <a
            v-else
            href="#"
            class="list-group-item list-group-item-action disabled"
            aria-current="true"
          >
            Please type the name for the student to search....
          </a>
          <router-link
            v-for="(searchableStudent, index) in searchedStudents"
            :key="index"
            :to="'/students/details/' + searchableStudent.sid"
            class="list-group-item list-group-item-action"
            aria-current="true"
          >
            {{ searchableStudent.student.name }} | Course:
            {{ searchableStudent.course.name }} | Level:
            {{ searchableStudent.classx.short }}
          </router-link>
        </div>
      </div>
    </div>
    <!-- <hr/> -->
    <div class="row">
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_total_students')
          )
        "
      >
        <div class="card mini-stats-wid color-box bg-info bg-gradient">
          <router-link class="text-success" to="/students">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Total Students</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.totStudents : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_total_staff')
          )
        "
      >
        <div
          class="card mini-stats-wid color-box color-box bg-dark bg-gradient"
        >
          <router-link class="text-success" to="/staff/staff">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Total Staff</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.staff : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_revenue_budget')
          )
        "
      >
        <div class="card mini-stats-wid bg-primary opacity-75">
          <router-link class="text-success" to="/revenue/projection">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Revenue Budget</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.revbudget : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_expense_budget')
          )
        "
      >
        <div class="card mini-stats-wid color-box bg-success">
          <router-link class="text-success" to="/expense/projection">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Expense Budget</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.expbudget : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_total_revenues')
          )
        "
      >
        <div class="card mini-stats-wid color-box bg-danger bg-gradient">
          <router-link class="text-success" to="/budget/view">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">
                    Exemptions
                  </p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.bur_exe : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_total_expenses')
          )
        "
      >
        <div class="card mini-stats-wid color-box bg-warning bg-gradient">
          <router-link class="text-success" to="/budget/view">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Total Expenses</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.expenses : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_expected_fees')
          )
        "
      >
        <div class="card mini-stats-wid bg-primary opacity-75">
          <router-link class="text-success" to="/fees/structure">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Expected Fees</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.expected_fees : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_collected_fees')
          )
        "
      >
        <div class="card mini-stats-wid color-box bg-success">
          <router-link class="text-success" to="/fees/payments">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-white fw-medium mb-2">Collected Fees</p>
                  <h4 class="mb-0 text-white">
                    {{ Dashboard ? Dashboard.collected_fees : 0 }}
                  </h4>
                </div>

                <div
                  class="
                    avatar-sm
                    align-self-center
                    mini-stat-icon
                    rounded-circle
                    bg-primary
                  "
                >
                  <span class="avatar-title">
                    <i class="bx bx-copy-alt font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- end card-body -->
        </div>
      </div>
    </div>
    <!-- end row -->

    <!-- end row -->
    <div class="row mt-4">
      <div
        class="col-md-6"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_student_graph')
          )
        "
      >
        <h4>Students Per Class</h4>
        <apexchart
          class="apex-charts"
          height="350"
          type="bar"
          dir="ltr"
          :series="studentPerClass.series"
          :options="studentPerClass.chartOptions"
        ></apexchart>
      </div>
      <div
        class="col-md-6"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_fees_graph')
          )
        "
      >
        <h4>Fees Collection Per Class</h4>
        <apexchart
          class="apex-charts"
          height="350"
          type="bar"
          dir="ltr"
          :series="feesPerClass.series"
          :options="feesPerClass.chartOptions"
        ></apexchart>
      </div>
    </div>

    <div class="row mt-4">
      <div
        class="col-md-12"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('view_revenue_expenses_graph')
          )
        "
      >
        <h4>Revenues Vs Expenses Graph</h4>
        <apexchart
          class="apex-charts"
          height="380"
          type="line"
          dir="ltr"
          :series="expenseVsRevenue.series"
          :options="expenseVsRevenue.chartOptions"
        ></apexchart>
      </div>
    </div>
  </Layout>
</template>
